/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { customersList } from "../../funcs/customersList.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  pageNumber: z.number().default(1),
  pageSize: z.number().default(50),
};

export const tool$customersList: ToolDefinition<typeof args> = {
  name: "customers-list",
  description: `List all customers

Retrieve a paginated list of all customers. Filter and search through your customer base.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await customersList(
      client,
      args.pageNumber,
      args.pageSize,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
